export default {
  SET_CAPITALIZATION(state, payload) {
    state.mega = payload.MarketCapMega;
    state.large = payload.MarketCapLarge;
    state.medium = payload.MarketCapMedium;
    state.mediam = payload.MarketCapMedian;
    state.small = payload.MarketCapSmall;
    state.micro = payload.MarketCapMicro;
    state.asOfDate = payload.asOfDate;
  }
};
